/**
 * 해외 시세(금/은/백금) API.
 *
 * metals-api.com 에서 받아 metal_price_history 에 쌓은 것을 읽는다.
 * 기존 현물시세(/api/v1/metal-price, metals.dev 금/은)와 같은 표를 쓰고
 * source 로만 갈린다 - 두 소스를 나란히 비교할 수 있다.
 *
 * 권한: HQ(본사) 관리자 전용
 */
import api from './index'

const BASE = '/api/v1/metal-price/overseas'

/**
 * 차트 데이터.
 *
 * @param {Object} params
 *   @param {string}   [params.source]     METALS_DEV(기본). 수집을 공용 서버로 모은 뒤 METALS_API 로는 들어오지 않는다
 *   @param {string[]} [params.metalTypes] GOLD / SILVER / PLATINUM. 비우면 전체
 *   @param {string}   [params.startDate]  yyyy-MM-dd
 *   @param {string}   [params.endDate]    yyyy-MM-dd
 * @returns {Promise} data: {
 *   series:  { GOLD: [{quotedAt, price}], SILVER: [...], PLATINUM: [...] },
 *   latest:  [{ metalType, source, quotedAt, price, currency, unit }],
 *   sources: [{ source, metalCount, rowCount, firstQuotedAt, lastQuotedAt }]
 * }
 */
export function getOverseasPriceChart(params) {
  return api.get(BASE, {
    params,
    // metalTypes 를 metalTypes=GOLD&metalTypes=SILVER 로 펼친다.
    // 기본 직렬화는 metalTypes[]= 로 나가서 스프링이 못 받는다.
    paramsSerializer: {
      indexes: null,
    },
  })
}

